<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div>
    <section class="content-header row">
        <div class="col-md-12 box-header">
            <h2 class="box-title">
                <strong>Manage Customer</strong>
            </h2>
            <div
                *ngIf="user.role !== 'Customer Admin' && user.role !== 'Customer Coordinator' && !isInternalReadOnly"
                class="pull-right box-tools"
            >
                <button
                    class="header-btn"
                    style="width: auto !important"
                    title="Add Members"
                    type="submit"
                    (click)="openAddCustomer('Add Customer', false)"
                >
                    <ds-icon name="add_circle" size="md" aria-hidden="true"></ds-icon><span style="padding-left: 5px">Customer</span>
                </button>
            </div>
        </div>
    </section>
    <section class="content footerPosition">
        <div class="row">
            <div class="col-xs-12">
                <div class="card card-layout-tab">
                    <div *ngIf="user.role != 'Customer Admin' && user.role != 'Customer Coordinator'" class="card-layout card-margin">
                        <div>
                            <h4 class="filter-content-container row">Filter Options</h4>
                            <hr class="horizontal-line-style" />
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <div>
                                        <label>Name</label>
                                        <ng-multiselect-dropdown-angular7
                                            [settings]="dropdownSettingsForName"
                                            [data]="customerNameList"
                                            [placeholder]="'Name'"
                                            [(ngModel)]="selectedCustomerItem"
                                        >
                                        </ng-multiselect-dropdown-angular7>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-4">
                                    <div>
                                        <label>City</label>
                                        <ng-multiselect-dropdown-angular7
                                            [settings]="cityDropdownSettings"
                                            [data]="cities"
                                            [placeholder]="'City'"
                                            [(ngModel)]="selectCity"
                                        >
                                        </ng-multiselect-dropdown-angular7>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4 col-sm-4">
                                    <div>
                                        <label>State</label>
                                        <ng-multiselect-dropdown-angular7
                                            [settings]="dropdownSettings"
                                            [data]="StateList"
                                            [placeholder]="'State'"
                                            [(ngModel)]="selectedState"
                                        >
                                        </ng-multiselect-dropdown-angular7>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-1 col-sm-4 margin-top-5">
                                    <div>
                                        <div class="">
                                            <label style="color: white"> .</label>
                                            <button
                                                id="close"
                                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn"
                                                style="font-size: 14px"
                                                type="submit"
                                                (click)="currentPage = 1; applyFilter()"
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-1 col-sm-4 margin-top-5">
                                    <div>
                                        <div class="form-group">
                                            <label style="color: white"> .</label>
                                            <button
                                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 flat-danger-butt"
                                                style="font-size: 14px"
                                                type="button"
                                                (click)="clearFilter()"
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row filter-section">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="col-xl-7 col-lg-6 col-md-6 col-sm-8 col-xs-8">
                                <div class="">
                                    Show
                                    <select
                                        class="margin-left-7 custom-select custom-select-sm grid-header-element number-sort-filter"
                                        aria-controls="example1"
                                        name="example1_length"
                                        [(ngModel)]="selectedPage"
                                        (change)="selectedPageCurrent()"
                                    >
                                        <option *ngFor="let number of numberOfEntries" [value]="number">
                                            {{ number }}
                                        </option>
                                    </select>
                                    entries
                                </div>
                            </div>
                            <div class="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                <span
                                    class="text-color text-color1 cursorPointer mt-2 pb-2"
                                    style="float: right"
                                    (click)="showAllCustomer()"
                                    >{{ this.dataFilter.isShowAllCustomers == false ? 'Show All' : 'Show Active' }}</span
                                >
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div id="example1_filter" class="d-flex" style="float: right">
                                    Search<input
                                        id="searchInput"
                                        class="margin-left-7 form-control form-control-sm grid-header-element searchbar-element"
                                        aria-controls="example1"
                                        type="text"
                                        [(ngModel)]="searchText"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body-tab">
                        <div class="col-12 px-2">
                            <div class="cards-body">
                                <div class="tableSpacing">
                                    <div class="box-body">
                                        <table id="example1" class="table card-layout table-striped table">
                                            <thead>
                                                <tr>
                                                    <td class="header_td table_heading">
                                                        <div class="header_container text-primary">
                                                            <div
                                                                class="header_title cursorPointer"
                                                                (click)="sortBy = 'name'; sortOrder = !sortOrder; name = !name"
                                                            >
                                                                Name
                                                                <ds-icon
                                                                    *ngIf="name == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="name == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'contact.primaryContact';
                                                                    sortOrder = !sortOrder;
                                                                    primaryContact = !primaryContact
                                                                "
                                                            >
                                                                Phone
                                                                <ds-icon
                                                                    *ngIf="primaryContact == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="primaryContact == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'contact.customerTypeName';
                                                                    sortOrder = !sortOrder;
                                                                    type = !type
                                                                "
                                                            >
                                                                Type
                                                                <ds-icon
                                                                    *ngIf="type == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="type == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                class="header_title cursorPointer"
                                                                (click)="sortBy = 'contact.emailId'; sortOrder = !sortOrder; email = !email"
                                                            >
                                                                Email
                                                                <ds-icon
                                                                    *ngIf="email == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="email == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div *ngIf="user.role != 'Customer Coordinator'" class="header_title">
                                                                Action
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="
                                                        let customer of customerList
                                                            | orderBy: sortBy : sortOrder
                                                            | paginate
                                                                : {
                                                                      itemsPerPage: selectedPage,
                                                                      currentPage: currentPage,
                                                                      totalItems: totalCount,
                                                                  };
                                                        let i = index
                                                    "
                                                >
                                                    <td>
                                                        <div class="row_container">
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: customer.isEnable == false }"
                                                            >
                                                                <div class="row_title">Name</div>
                                                                <div class="row_detail">
                                                                    <a
                                                                        *ngIf="!isInternalReadOnly"
                                                                        class="cursorPointer text-color"
                                                                        href="{{ url }}/common-details/customer/{{ customer.customerId }}"
                                                                        (click)="openVendorDetailPage(customer.customerId)"
                                                                        >{{ customer.name }}</a
                                                                    >
                                                                    <span *ngIf="isInternalReadOnly">{{ customer.name }}</span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: customer.isEnable == false }"
                                                            >
                                                                <div class="row_title">Phone</div>
                                                                <div class="row_detail">
                                                                    <a
                                                                        *ngIf="!isInternalReadOnly"
                                                                        class="phonenumberlink"
                                                                        href="tel:+1{{ customer.contact.phone }}"
                                                                    >
                                                                        {{ customer.contact.phone | phoneNumberPipe }}
                                                                    </a>
                                                                    <span *ngIf="isInternalReadOnly">
                                                                        {{ customer.contact.phone | phoneNumberPipe }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: customer.isEnable == false }"
                                                            >
                                                                <div class="row_title">Type</div>
                                                                <div class="row_detail" style="word-break: break-all">
                                                                    {{ customer.customerTypeName }}
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: customer.isEnable == false }"
                                                            >
                                                                <div class="row_title">Email</div>
                                                                <div class="row_detail" style="word-break: break-all">
                                                                    {{ customer.contact.emailId }}
                                                                </div>
                                                            </div>
                                                            <div *ngIf="user.role != 'Customer Coordinator'" class="title_container">
                                                                <div class="row_title">Action</div>
                                                                <div class="row_detail">
                                                                    <div
                                                                        *ngIf="
                                                                            user.role != 'Customer Admin' &&
                                                                            user.role != 'Coordinator' &&
                                                                            user.role != 'Management'
                                                                        "
                                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer py-1 px-1 pb-0"
                                                                        [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                                        [title]="
                                                                            customer.isEnable == true
                                                                                ? 'Disable Customer'
                                                                                : 'Enable Customer'
                                                                        "
                                                                    >
                                                                        <div class="checkbox checbox-switch switch-danger my-0 py-0">
                                                                            <label [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''">
                                                                                <input
                                                                                    name=""
                                                                                    type="checkbox"
                                                                                    [checked]="customer.isEnable == true ? true : false"
                                                                                    [disabled]="isInternalReadOnly"
                                                                                    (change)="disableCustomer(customer.customerId, $event)"
                                                                                />
                                                                                <span></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        class="flat-butt flat-info-butt flat-info-grad-butt pt-1"
                                                                        title="Edit Customer"
                                                                        [disabled]="
                                                                            (customer.isEnable == false ? true : false) ||
                                                                            isInternalReadOnly
                                                                        "
                                                                        [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                                        (click)="
                                                                            openEditCustomer(
                                                                                'Edit Customer',
                                                                                true,
                                                                                customer,
                                                                                customer.customerId
                                                                            )
                                                                        "
                                                                    >
                                                                        <ds-icon name="edit_square" size="inherit"></ds-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div *ngIf="customerList.length == 0" class="mt-2" style="color: #a82b41">
                                            <b>No Record Found</b>
                                        </div>
                                        <div *ngIf="customerList.length > 0" class="col-md-12 p-0" style="margin-top: 10px">
                                            <div class="col-md-6 p-0">
                                                {{ pagination }}
                                            </div>

                                            <div class="col-md-6 pagination text-end mt-1">
                                                <pagination-controls
                                                    [maxSize]="6"
                                                    [nextLabel]="''"
                                                    [previousLabel]="''"
                                                    [responsive]="responsive"
                                                    (pageChange)="currentPage = $event; currentPageChange()"
                                                >
                                                </pagination-controls>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
